export default function homePageContentBlock() {
  const modals = document.querySelectorAll('[data-js="video-modal"]');

  if (!modals.length) return;

  const openVideo = (modal, frame, { source, youtubeId, fileUrl }) => {
    if (!source) return;

    frame.innerHTML = ""; // reset

    if (source === "youtube") {
      if (!youtubeId) return;

      frame.innerHTML = `
        <iframe
          src="https://www.youtube-nocookie.com/embed/${youtubeId}?autoplay=1&rel=0&playsinline=1&modestbranding=1"
          title="YouTube video"
          frameborder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          allowfullscreen
        ></iframe>
      `;
    }

    if (source === "file_upload") {
      if (!fileUrl) return;

      frame.innerHTML = `
        <video controls autoplay playsinline>
          <source src="${fileUrl}" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      `;
    }

    modal.hidden = false;
    document.documentElement.classList.add("is-video-open");
  };

  const closeVideo = (modal, frame) => {
    modal.hidden = true;
    frame.innerHTML = ""; // stops video (iframe/video)
    document.documentElement.classList.remove("is-video-open");
  };

  modals.forEach((modal) => {
    const section = modal.closest("section") || modal.parentElement;
    const frame = modal.querySelector('[data-js="video-frame"]');
    const closeEls = modal.querySelectorAll('[data-js="video-close"]');
    const openBtns = section ? section.querySelectorAll('[data-js="video-open"]') : [];

    if (!frame || !openBtns.length) return;

    openBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        openVideo(modal, frame, {
          source: btn.dataset.videoSource,
          youtubeId: btn.dataset.youtubeId,
          fileUrl: btn.dataset.videoFile,
        });
      });
    });

    closeEls.forEach((el) => el.addEventListener("click", () => closeVideo(modal, frame)));
  });

  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;

    modals.forEach((modal) => {
      if (modal.hidden) return;

      const frame = modal.querySelector('[data-js="video-frame"]');

      if (frame) {
        closeVideo(modal, frame);
      }
    });
  });
}
